import { render, staticRenderFns } from "./IconFileExcel.vue?vue&type=template&id=a883215a&"
import script from "./IconFileExcel.vue?vue&type=script&lang=ts&"
export * from "./IconFileExcel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports